export default __webpack_public_path__ + "static/nftix_temp_hero_img-b2e69feb7f885d573d1ee9a2b1c60972.jpg";